"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _ComponentContainer = require("../../../Framework/ComponentContainer");
var _AlertDialog = _interopRequireDefault(require("../Components/AlertDialog"));
var _ServiceLocator = require("../../ServiceLocator");
var _i18n = require("../../../Framework/i18n");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var mapStateToProps = function mapStateToProps(_ref) {
  var error = _ref.ui.error;
  return {
    Component: _AlertDialog["default"],
    message: error && (error.message || error.type && (0, _i18n.t)("errorTypes.".concat(error.type)) || (0, _i18n.t)('errorTypes.unknown')),
    title: (0, _i18n.t)('errorDialogTitle')
  };
};
var mapDispatchToProps = function mapDispatchToProps() {
  return {
    dismissMessage: function dismissMessage() {
      return _ServiceLocator.Services.ui.dismissError();
    }
  };
};
var _default = exports["default"] = (0, _ComponentContainer.containerConnect)(mapStateToProps, mapDispatchToProps);